import { useTranslation } from 'react-i18next';

export default function ContactInfo() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('contact.info.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('contact.info.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('contact.info.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('contact.info.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Phone */}
          <div className="bg-background-100/60 border border-background-200/60 p-7 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-accent-500">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.08em] mb-3 font-label">
              {t('contact.info.phone')}
            </h3>
            <a
              href="tel:0368244086"
              className="block text-[17px] text-foreground-900 tracking-[0.04em] mb-2 hover:text-accent-600 transition-colors"
            >
              03-6824-4086
            </a>
            <p className="text-[14px] text-foreground-400 tracking-[0.04em]">
              {t('contact.info.phoneHours')}
            </p>
          </div>

          {/* Email */}
          <div className="bg-background-100/60 border border-background-200/60 p-7 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-accent-500">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.08em] mb-3 font-label">
              {t('contact.info.email')}
            </h3>
            <a
              href="mailto:info@butler-academy.jp"
              className="block text-[16px] text-accent-600 tracking-[0.04em] hover:text-accent-500 transition-colors break-all"
            >
              info@butler-academy.jp
            </a>
            <p className="text-[14px] text-foreground-400 tracking-[0.04em] mt-2">
              {t('contact.info.emailReply')}
            </p>
          </div>

          {/* Location */}
          <div className="bg-background-100/60 border border-background-200/60 p-7 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-accent-500">
              <i className="ri-map-pin-line text-2xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.08em] mb-3 font-label">
              {t('contact.info.address')}
            </h3>
            <p className="text-[15px] text-foreground-800 tracking-[0.04em] leading-relaxed whitespace-pre-line">
              {t('contact.info.addressText')}
            </p>
            <a
              href="/access"
              className="inline-flex items-center gap-1 text-[14px] text-accent-600 hover:text-accent-500 transition-colors mt-3 tracking-[0.04em]"
            >
              {t('contact.info.accessLink')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
